import React, { useContext } from 'react'
import { IoMdCheckmark } from 'react-icons/io'
import { MdCancel } from 'react-icons/md'
import { ImCross } from "react-icons/im";
import Accept from './Accept';
import Reject from './Reject';
import { BasePopupContext } from '../../../hooks/usePopup';
import { DATE_FORMAT_SERVER, POPUP_LARGE, POPUP_SMALL, STATUS_ACCEPTED, STATUS_PENDING, STATUS_REJECTED } from '../../../constants';
import { DateTime } from 'luxon';
import { StatusTag } from '../../../components/Reuseable/Tag';
import StatusChange from './StatusChange';
import { FormattedMessage } from 'react-intl';

const Actions = ({ data,refreshListing, item,fromAgency }) => {
    const { setPopup } = useContext(BasePopupContext);

    const handleAccept = (e) => {
        e.stopPropagation()
        setPopup({
            heading: "Accept Deliverable",
            component: <StatusChange refreshListing={refreshListing} fromAgency={fromAgency} data={data} accept={true} />,
            size: POPUP_SMALL
        })
    }
    const handleReject = (e) => {
        e.stopPropagation()
        setPopup({
            heading: "Reject Deliverable",
            component: <StatusChange refreshListing={refreshListing} fromAgency={fromAgency} data={data} item={item} accept={false}/>,
            size: POPUP_SMALL
        })
    }

    return (
        <>
            <hr className='h-[2px]' />
            <div className='flex flex-row items-center justify-end space-x-5 mt-5'>
                {data?.status !== STATUS_PENDING.value ?
                   <>
                    <StatusTag status={data?.status} />
                   </>
                    :
                    item?.release_dates && DateTime.now().toFormat(DATE_FORMAT_SERVER) > DateTime.fromISO(item?.release_dates[0]?.release_date) ?
                        <div className={`${STATUS_REJECTED.backgroundColor} ${STATUS_REJECTED.textColor} px-3 py-1 rounded-md text-xs`}>
                            <FormattedMessage id="deadline_exceeded" defaultMessage={"Deadline Exceeded"} />
                        </div>
                    :
                        <>
                            <button
                                onClick={(e)=>handleReject(e)}
                                className={`py-1 inline-flex space-x-2 items-center justify-center hover:-translate-y-1 transition-all duration-200 text-sm bg-red-500/70 text-white  px-4 rounded-md`}>
                                <span><FormattedMessage id="reject" defaultMessage={"Reject"} /></span>
                                <ImCross className='text-sm' />
                            </button>

                            <button
                                onClick={(e)=>handleAccept(e)}
                                className={` inline-flex space-x-2 items-center justify-center py-1  hover:-translate-y-1 transition-all duration-200   text-sm bg-green-600/70 text-white  px-4 rounded-md`}>
                                <span><FormattedMessage id="accept" defaultMessage={"Accept"} /></span>
                                <IoMdCheckmark className='text-xl' />
                            </button>
                        </>
                }
            </div>




        </>
    )
}

export default Actions